<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <setup-education-container-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupEducationContainerView: () => import('@/components/hris/setup/education/ContainerView'),
    },
    metaInfo () {
      return {
        title: 'Setup Education',
      }
    },
  }
</script>
